import { PathModule } from "app/common/LocalConst";
import { EgretLoadable } from "egret";

const DashBoardRoute = {
  path: PathModule.DASHBOARD,
  exact: true,
  children: [
    {
      path: "revenue",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Revenue/RevenueIndex"),
      }),
    },
    {
      path: "hospital-data",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./HospitalData/HospitalDataIndex"),
      }),
    },
    {
      path: "overview",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Overview/OverviewIndex"),
      }),
    },
    {
      path: "chart-statistics",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ChartStatistics/ChartStatisticsIndex"),
      }),
    },
    {
      path: "embedded-iframe",
      exact: true,
      component: EgretLoadable({
        loader: () => import("app/EmbeddedIFrame/EmbeddedIFrameIndex"),
      }),
    },
  ],
};

export default DashBoardRoute;
